import styled from 'styled-components';

const IdentifierValue = styled.span`
  display: inline-block;
  font-family: monospace;
  max-width: 100%;
  overflow-wrap: anywhere;
  white-space: normal;
`;

export default IdentifierValue;
